export const RECOMMENDED_PRICE_CONTROL_GA_PARAMETER = 'PPA-12337-control'
export const RECOMMENDED_PRICE_TREATMENT_GA_PARAMETER = 'PPA-12337-treatment'

export type RecommendedPriceExperimentTrackingParameters = {
  ga_cd_test_ppa: string
}

type RecommendedPriceExperimentStateParams = {
  isRecommendedPriceFlowOptionEnabled: boolean
  isRecommendedPriceFeatureLoadedFromBackend: boolean
  recommendedPriceFeatureValue: boolean | undefined
}

export type RecommendedPriceExperimentState = {
  isInExperiment: boolean
  isRecommendedPriceEnabled: boolean
  trackingParameters?: RecommendedPriceExperimentTrackingParameters
}

export function getRecommendedPriceExperimentState({
  isRecommendedPriceFlowOptionEnabled,
  isRecommendedPriceFeatureLoadedFromBackend,
  recommendedPriceFeatureValue,
}: RecommendedPriceExperimentStateParams): RecommendedPriceExperimentState {
  const isInExperiment =
    isRecommendedPriceFlowOptionEnabled &&
    isRecommendedPriceFeatureLoadedFromBackend &&
    recommendedPriceFeatureValue !== undefined

  if (!isInExperiment) {
    return {
      isInExperiment: false,
      isRecommendedPriceEnabled: false,
    }
  }

  const isTreatment = recommendedPriceFeatureValue === true

  return {
    isInExperiment: true,
    isRecommendedPriceEnabled: isTreatment,
    trackingParameters: {
      ga_cd_test_ppa: isTreatment ? RECOMMENDED_PRICE_TREATMENT_GA_PARAMETER : RECOMMENDED_PRICE_CONTROL_GA_PARAMETER,
    },
  }
}
